import type { ArticleRow } from '../../../shared/schemas/article';

const LANDING_LARGE_FEATURE_COUNT = 3;
const LANDING_SMALL_FEATURE_COUNT = 2;
export const LANDING_FEATURE_COUNT = LANDING_LARGE_FEATURE_COUNT + LANDING_SMALL_FEATURE_COUNT;

export function splitLandingFeatures(articles: ArticleRow[]): {
  large: ArticleRow[];
  small: ArticleRow[];
} {
  return {
    large: articles.slice(0, LANDING_LARGE_FEATURE_COUNT),
    small: articles.slice(
      LANDING_LARGE_FEATURE_COUNT,
      LANDING_LARGE_FEATURE_COUNT + LANDING_SMALL_FEATURE_COUNT,
    ),
  };
}

export function landingFeatureImagePosition(index: number): 'left' | 'right' {
  return index % 2 === 0 ? 'right' : 'left';
}
